import {
    INVALID_DOCUMENT_ERROR_TEXT_BY_DOCUMENT_TYPE_AGGREGATION,
    VIDEO_CALL_MODAL_CONTENT_BY_STATUS_CODE,
    VIDEOSELFIE_DIRECT_ERROR_TEXT_BY_STATUS_CODE,
} from 'constants/video/statusTexts';
import { getDocumentTypeAggregation } from 'utilities/documentTypes';
import { ERROR, INVALID_DOCUMENT } from 'constants/video/status';

const getInvalidDocumentMessage = documentType => {
    const documentTypeAggregation = getDocumentTypeAggregation(documentType);

    return (
        INVALID_DOCUMENT_ERROR_TEXT_BY_DOCUMENT_TYPE_AGGREGATION[documentTypeAggregation] ??
        VIDEOSELFIE_DIRECT_ERROR_TEXT_BY_STATUS_CODE[INVALID_DOCUMENT]
    );
};

const getTextMessageByVideoSelfieStatusCode = ({ documentType, statusCode }) => {
    if (statusCode === INVALID_DOCUMENT) return getInvalidDocumentMessage(documentType);

    return (
        VIDEOSELFIE_DIRECT_ERROR_TEXT_BY_STATUS_CODE[statusCode] ?? VIDEOSELFIE_DIRECT_ERROR_TEXT_BY_STATUS_CODE[ERROR]
    );
};

const getTextMessageByVideoCallStatusCode = ({ statusCode }) =>
    VIDEO_CALL_MODAL_CONTENT_BY_STATUS_CODE[statusCode] ?? VIDEO_CALL_MODAL_CONTENT_BY_STATUS_CODE[ERROR];

export const getTextMessageByVideoStatusCode = ({ isVideoSelfie, documentType, statusCode }) => {
    if (isVideoSelfie) return getTextMessageByVideoSelfieStatusCode({ documentType, statusCode });

    return getTextMessageByVideoCallStatusCode({ statusCode });
};
